import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { ArrowBackIcon } from "@dotnet/telematics-design-system";

import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import AuthContext from "context/auth/authContext";
import { svgFontSize } from "shared/styles/styleFunctions";

import { BackButtonProps } from "./types";

const BackButton = ({
    isRecoveryCodePhase,
    handleRecoveryCodePhase,
    resetOtpError
}: BackButtonProps) => {
    const { toggle2FaVerification } = useContext(AuthContext);

    const { t } = useTranslation();

    const handleClick = () => {
        isRecoveryCodePhase
            ? handleRecoveryCodePhase(false)
            : toggle2FaVerification(false);

        resetOtpError();
    };

    return (
        <TextLink
            size={TEXT_LINK_SIZES.Large}
            onClick={handleClick}
            css={css({
                marginBottom: "24px",

                "& > svg": {
                    marginRight: "8px",
                    marginLeft: "0",
                    ...svgFontSize(16)
                }
            })}
        >
            <ArrowBackIcon />
            {t("Button##back")}
        </TextLink>
    );
};

export default BackButton;
